import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

export const faqs = [
  {
    q: "What documents are required for a loan application?",
    a: "Typical requirements are KYC (Aadhaar + PAN), address proof, income proof (last 3-6 months' salary slips or 1-2 years' ITR for self-employed), 6 months' bank statements, and for secured loans — property documents. Our team provides a precise checklist once we know the product and lender.",
  },
  {
    q: "How long does loan approval and disbursal take?",
    a: "Personal loans are typically decisioned in 24-72 hours and disbursed within 3-5 working days. Home loans and LAP usually take 7-15 working days depending on property and legal verification. Business loans typically take 5-10 working days.",
  },
  {
    q: "What credit score do I need to qualify?",
    a: "A CIBIL score of 700+ is generally considered healthy. 750+ unlocks the best rates. We work with multiple lenders, so even applicants with scores between 650-700 can often find suitable options — though rates may be slightly higher.",
  },
  {
    q: "Can I apply for a loan if I am self-employed?",
    a: "Yes. Self-employed applicants typically need 2-3 years of ITR, audited financials, GST returns and bank statements. We have lenders specifically positioned for self-employed and business-owner profiles across our panel.",
  },
  {
    q: "What is FOIR and how does it affect eligibility?",
    a: "FOIR (Fixed Obligation to Income Ratio) is the share of your income that can go towards EMIs. Lenders typically cap FOIR at 40-60% depending on income. Your maximum loan eligibility is computed so that total EMIs (including new + existing) stay within the allowed FOIR.",
  },
  {
    q: "What is balance transfer and when should I consider it?",
    a: "Balance transfer moves your existing loan to another lender offering a lower interest rate. It makes sense when the rate difference is 0.5%+ and you have significant tenure remaining. We evaluate processing fees and net savings before recommending a transfer.",
  },
  {
    q: "Are there any hidden charges or fees?",
    a: "No. We share all charges upfront — processing fees, documentation, legal/technical (for secured loans), stamp duty (where applicable) and prepayment terms. Our process is transparent and audit-ready.",
  },
  {
    q: "Can I prepay or foreclose my loan?",
    a: "Yes. For floating-rate loans taken by individuals, the RBI disallows prepayment penalties. Fixed-rate loans and business loans may attract a small foreclosure fee (typically 1-4%). We highlight this in the sanction letter review.",
  },
  {
    q: "Do I need a co-applicant?",
    a: "Co-applicants are optional but recommended when you want to enhance eligibility — especially for home loans. A spouse, parent or sibling with stable income can be added as a co-applicant to boost the sanctioned amount.",
  },
  {
    q: "How is the home loan interest rate calculated?",
    a: "Most home loans use floating rates linked to the RBI Repo Rate (Repo + spread). Your EMI is calculated on the reducing-balance method. As the principal reduces each month, the interest component drops and the principal component rises.",
  },
  {
    q: "What is LAP (Loan Against Property)?",
    a: "LAP is a secured loan where you pledge a residential or commercial property to borrow funds for any end use — business expansion, medical, education, debt consolidation, etc. Ticket sizes are higher and tenures longer compared to unsecured options.",
  },
  {
    q: "How does DVP DIGI WORLD select the right lender for me?",
    a: "We evaluate your profile against our panel of banks and NBFCs, considering rate, tenure, eligibility fit, processing speed and any product-specific benefits. We present 2-3 best-fit options so you can make an informed choice.",
  },
  {
    q: "Is my personal and financial data secure?",
    a: "Yes. We follow audit-ready processes with strict data handling. Information is shared only with the lender(s) you agree to, and all interactions are documented for traceability.",
  },
  {
    q: "What insurance products do you offer?",
    a: "Life, health, motor, vehicle and general insurance through partnerships with leading insurers. We also help with claim assistance and renewal reminders for long-term protection planning.",
  },
];

export default function FAQSection({ limit, compact = false }) {
  const list = limit ? faqs.slice(0, limit) : faqs;
  return (
    <div data-testid="faq-section" className={compact ? "" : "space-y-2"}>
      <Accordion type="single" collapsible className="w-full">
        {list.map((f, i) => (
          <AccordionItem
            key={i}
            value={`faq-${i}`}
            data-testid={`faq-item-${i}`}
            className="border-b border-white/10 last:border-b-0"
          >
            <AccordionTrigger className="py-5 text-left text-white hover:no-underline hover:text-[#dc2626] font-display text-base sm:text-lg font-semibold">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-neutral-400 leading-relaxed text-[15px] pb-6 pt-0">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
